/**
 * Convertit un ProductBrief en texte prompt pour la génération IA
 * Utilisé pour rétrocompatibilité avec customDescription et pour construire le prompt
 */

import type { ProductBrief } from "../types/productBrief";

export function productBriefToPrompt(brief: ProductBrief | null | undefined, t?: (key: string) => string): string {
  if (!brief) return "";

  const tr = t || ((k: string) => k);
  const lines: string[] = [];

  const { baseInfo, sellingPoints, painPoints, features, freeformNotes, qaPairs, assertions } = brief;

  if (baseInfo?.productName || baseInfo?.brand) {
    if (baseInfo.productName) lines.push(`${tr("product")}: ${baseInfo.productName}`);
    if (baseInfo.brand) lines.push(`${tr("brand")}: ${baseInfo.brand}`);
    if (baseInfo.targetAudience) lines.push(`${tr("targetAudience")}: ${baseInfo.targetAudience}`);
    lines.push("");
  }

  if (Array.isArray(sellingPoints) && sellingPoints.length > 0) {
    lines.push(`${tr("sellingPoints")}:`);
    sellingPoints.forEach((sp) => lines.push(`- ${sp}`));
    lines.push("");
  }

  if (Array.isArray(painPoints) && painPoints.length > 0) {
    lines.push(`${tr("painPointsResolved")}:`);
    painPoints.forEach((pp) => {
      const part = pp.solution ? `${pp.problem} → ${pp.solution}` : pp.problem;
      lines.push(`- ${part}`);
    });
    lines.push("");
  }

  if (Array.isArray(features) && features.length > 0) {
    lines.push(`${tr("features")}:`);
    features.forEach((f) => lines.push(`- ${f}`));
    lines.push("");
  }

  if (Array.isArray(qaPairs) && qaPairs.length > 0) {
    lines.push(`${tr("details")}:`);
    qaPairs.forEach((qa) => lines.push(`- ${qa.question} ${qa.answer}`));
    lines.push("");
  }

  if (Array.isArray(assertions) && assertions.length > 0) {
    lines.push(`${tr("analysisMode")} Results:`);
    assertions.forEach((ar) => {
      let line = `- [${ar.assertion}] -> ${ar.result}`;
      if (ar.nuance) line += ` (${ar.nuance})`;
      lines.push(line);
    });
    lines.push("");
  }

  if (freeformNotes?.trim()) {
    lines.push(freeformNotes.trim());
  }

  return lines.join("\n").trim();
}
